import React from 'react'
import { useSelector } from 'react-redux'
import { selectProcessById } from '../../redux/selectors/processing.selectors'
import { RootStoreModel } from '../../redux/store.model'
import { FloatingProcessingProgress } from '../../pages/invoiceCycles/invoiceCyclesProcessing/components/floatingProcessingProgress'

interface ProcessingNotificationProps {
  processId: string
}

/**
 * Componente que maneja notificaciones flotantes para procesos en background
 * Usa tipos discriminados para delegar al componente específico de cada tipo de proceso
 */
export const ProcessingNotification: React.FC<ProcessingNotificationProps> = ({ processId }) => {
  const process = useSelector((state: RootStoreModel) => selectProcessById(state, processId))

  if (!process) {
    return null
  }

  // Type guard: delegar al componente específico según el tipo de proceso
  if (process.processType === 'invoiceCycle') {
    return (
      <FloatingProcessingProgress
        processId={processId}
        executionCycleId={process.executionCycleId}
        currentStatus={process.currentStatus}
        additionalState={process.additionalState}
        cycleName={process.cycleName}
      />
    )
  }

  // Agregar otros tipos de procesos aquí
  // if (process.processType === 'batchJob') {
  //   return <FloatingBatchJobProgress processId={processId} {...process} />
  // }

  return null
}
